import { render } from "./ContactTagContainer.vue?vue&type=template&id=77f5c782&scoped=true"
import script from "./ContactTagContainer.vue?vue&type=script&lang=js"
export * from "./ContactTagContainer.vue?vue&type=script&lang=js"

import "./ContactTagContainer.vue?vue&type=style&index=0&id=77f5c782&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f5c782"]])

export default __exports__